import { map, Observable, switchMap } from 'rxjs';
import { Guid, isNil, isNotNil, Nillable } from '@web/utils';
import { SelectItem } from '@web/shared/ui';
import { AbstractControl } from '@angular/forms';
import { AdminWarehouseGoodDataSourceService } from '../services/admin-warehouse-good-data-source.service';
import { AdminWarehouseGoodSelectItemsProviderService } from '../providers/admin-warehouse-good-select-items-provider.service';
import { adminWarehouseGoodCurrentSelectItem } from './admin-warehouse-good-current-select-item';

export const adminWarehouseGoodSelectItemsWithCurrentSelection = (options: {
  control: AbstractControl<Nillable<Guid>>;
  dataSource: AdminWarehouseGoodDataSourceService;
  selectItemsProvider: AdminWarehouseGoodSelectItemsProviderService;
  query: Nillable<string>;
}): Observable<SelectItem<Guid>[]> => {
  const { control, dataSource, selectItemsProvider, query = null } = options;

  return adminWarehouseGoodCurrentSelectItem({ control, dataSource }).pipe(
    switchMap((currentSelectItem) =>
      selectItemsProvider.fetchCollectionAsSelectItems('id', query).pipe(
        map((selectItems) => {
          if (isNil(currentSelectItem)) {
            return selectItems;
          }

          const isCurrentExists = isNotNil(
            selectItems.find((item) => item.value === currentSelectItem.value),
          );

          if (isCurrentExists) {
            return selectItems;
          }

          return [...selectItems, currentSelectItem];
        }),
      ),
    ),
  );
};
